/**
 * Extracts a consistent error shape from an axios error response.
 * Shared across all API services to avoid duplication.
 *
 * @param {unknown} err
 * @param {string} [defaultMessage='Unexpected error'] - Fallback message when the server doesn't provide one
 * @returns {{ status: number, message: string, field: string | null }}
 */
const normalizeError = (err, defaultMessage = 'Unexpected error') => {
  const e = /** @type {any} */ (err);
  return {
    status: e?.response?.status || 500,
    message: e?.response?.data?.message || defaultMessage,
    field: e?.response?.data?.field || null,
  };
};

export default normalizeError;
